import React, { Component } from 'react';
import { withRouter, setCookie, login_check, loginUrl, isLogin, LoadingSpinner } from './include/Common';
import {Helmet} from 'react-helmet';

import $ from 'jquery';
import axios from "axios";
import { Navigate } from "react-router-dom";

import Footer from './Footer';
//
class MyZzim extends Component {
   constructor(props) {
      super(props);
      this.state = {
         isLogin: false,   // 처음에 로딩 상태
         loading: true,
         zzimList: [],
         page: 1,
         order: 'u',
      };
   }
   componentDidMount() {
      // 페이지 로드 시 axios 호출
      this.fetchAccessCheck(1);

      $(document).on("click", ".comboBx__btn", function (e) {
         e.stopPropagation();

         const $btn = $(this);
         const $combo = $btn.closest(".comboBx");
         const $list = $combo.find(".comboBx__list");

         const isActive = $btn.hasClass("active");

         // 모든 콤보 초기화
         $(".comboBx__btn").removeClass("active");
         $(".comboBx__list").hide();

         // 현재 클릭한 것만 toggle
         if (!isActive) {
            $btn.addClass("active");
            $list.show();
         }
      });

      // 바깥 클릭 시 모든 콤보 닫기
      $(document).on("click", function () {
         $(".comboBx__btn").removeClass("active");
         $(".comboBx__list").hide();
      });
//
   }

   async fetchAccessCheck(pg) {
      const loginCheck = await login_check();

      if (!loginCheck) {
         window.location.href = loginUrl;
      }
      const publicUrl = process.env.PUBLIC_URL;
      let quizWordUrl = publicUrl + '/api/getUserZzim.php?ord=' + this.state.order + '&pg=' + pg;
      axios.get(quizWordUrl).then(response => {
         this.setState({
            isLogin: loginCheck,
            loading: false,
            totalCount: response.data.total,
            zzimList: response.data.zzim,
            page: pg,
         });
      });
   }

   handleButtonClick = async (targetIdx) => {
      const element = document.getElementById(`btn-${targetIdx}`);
      const isActive = element.classList.contains('active');

      this.setState(prevState => {
         const foundIndex = prevState.zzimList.findIndex(item => item.idx === targetIdx);

         if (foundIndex === -1) {
            console.error(`idx ${targetIdx}에 해당하는 항목이 없습니다.`);
            return null;
         }
         const updated = [...prevState.zzimList];
         updated[foundIndex] = {
            ...updated[foundIndex],
            uzzim: !updated[foundIndex].uzzim
         };
         const after = updated[foundIndex].uzzim;
         let md = 'setZzim';
         if (!after) md = 'unsetZzim';
         try {
            const ret = setWord(md, targetIdx);
            if (ret == 'setZzim') {
               element.className = 'zzim active';
            } else {
               element.className = 'zzim';
            }

            if (this.state.zzimList.length === 1 && this.state.page > 1) {
               this.fetchAccessCheck(this.state.page - 1); // 마지막 항목을 제거한 경우 이전 페이지 호출
            } else {
               this.fetchAccessCheck(this.state.page);
            }

         } catch (err) {
            console.error('버튼 클릭 처리 실패:', err);
         }
         return { zzimList: updated };
      });

   };

   handleOrderClick = async (order) => {
      order == 'abc' ? $('.comboBx__btn').text('가나다순') : $('.comboBx__btn').text('최신순');
      $('.comboBx__list').hide();
      this.setState({ order: order, page: 1 }, () => {
         this.fetchAccessCheck(1);
      });
   }
   render() {
      const { loading, isLogin, totalCount, page, order, infoList, zzimList } = this.state;

      const currentUrl = window.location.href;
      const structureData = {
         "@context": "https://schema.org",
         "@type": "WebSite",
         "name": "찜한 용어 - 지식포켓",
         "url": currentUrl,
      } 

      return loading ? <LoadingSpinner /> : (
         <>
            <Helmet>

               <title>찜한 용어 - 지식포켓</title>
               <meta name="keywords" content="지식포켓, 뉴스 용어, 시사 용어, 오늘의 용어, 용어 검색, OX 퀴즈, 객관식 퀴즈, 십자말풀이, 시사 상식, 뉴스 해설, 용어 사전" />
               <meta name="description" content="내가 저장한 관심 용어만 모아보기! 찜한 용어에서 쉽고 빠르게 복습하세요."/>

               <meta property="og:type" content="website" />
               <meta property="og:site_name" content="지식포켓" />
               <meta property="og:title" content="찜한 용어 - 지식포켓" />
               <meta property="og:description" content="내가 저장한 관심 용어만 모아보기! 찜한 용어에서 쉽고 빠르게 복습하세요."/>             
               <meta property="og:url" content={currentUrl} />
               <meta property="og:image" content="https://cwstatic.asiae.co.kr/pocket/og_img.png" /> 
               <meta property="og:image:width" content="1200" />
               <meta property="og:image:height" content="630" />
               <meta property="og:locale" content="ko_KR" />

               <link rel="canonical" href={currentUrl}/>
               <script type="application/ld+json">
               { JSON.stringify(structureData)}
               </script>
               
            </Helmet>         
            <main id="contents" data-page="my" className="page--my-zzim no-search-btn">
               <div className="title-bx">
                  <h1 className="tit">찜한 용어</h1>
                  {(zzimList && zzimList.length > 0) ? (
                     <p className="desc">용어를 클릭하면 상세 내용을 볼 수 있어요!</p>
                  ) : (<></>)}
               </div>
               {(zzimList && zzimList.length > 0) ? (
                  <div className="container">
                     <div className="comboBx">

                        <button className="comboBx__btn">최신순</button>
                        <ul className="comboBx__list">
                           <li><button type="button" onClick={() => this.handleOrderClick('u')} className={order == 'u' ? "link active" : "link"}>최신순</button></li>
                           <li><button type="button" onClick={() => this.handleOrderClick('abc')} className={order == 'abc' ? "link active" : "link"}>가나다순</button></li>
                        </ul>
                     </div>

                     <ul className="zzim-list">

                        {zzimList.map((item, index) => (
                           <li className="item">
                              <article className="word-card">
                                 <button type="button" id={`btn-${item.idx}`} className={item.uzzim ? 'zzim active' : 'zzim'} onClick={() => this.handleButtonClick(item.idx)}>
                                    <svg width="24" height="22" id={`svg-${item.idx}`} viewBox="0 0 24 22" fill="none" xmlns="http://www.w3.org/2000/svg" fillOpacity="0">
                                       <use xlinkHref="#zzim"></use>
                                    </svg>
                                    <span className="sr-only">찜하기 해제</span>
                                 </button>
                                 <a href={item ? `/View/${item.idx}` : '#'} className="wrap">
                                    <p className="tit">
                                       <span>{item.title}</span>
                                    </p>
                                    <p className="eng">{item.subtitle}</p>
                                 </a>
                              </article>
                           </li>
                        ))}


                     </ul>

                     <Pagination
                        totalCount={this.state.totalCount}
                        currentPage={this.state.page}
                        perPage={12}
                        onPageChange={(page) => {
                           this.setState({
                              page: page
                           });
                           window.scrollTo({ top: 0, behavior: 'smooth' });
                           this.fetchAccessCheck(page);
                           // 페이지 변경 처리 로직
                        }}
                     />
                  </div>
               ) : (
                  <section class="my-section zzim-word">
                     <div class="container">
                        <div class="word-null" style={{ height: 'auto', maxHeight: '300px', }}>
                           <p>찜한 용어가 없어요 😥</p>
                           <a class="btn" href="/WordList">용어 리스트 보기</a>
                        </div>
                     </div>
                  </section>
               )}
            </main>
            <Footer />
         </>
      );
   }
}

function Pagination({ totalCount, currentPage, perPage = 12, onPageChange }) {

   const totalPages = Math.ceil(totalCount / perPage);
   const maxVisiblePages = 5;

   const getPageNumbers = () => {
      const pages = [];
      let startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
      let endPage = startPage + maxVisiblePages - 1;

      if (endPage > totalPages) {
         endPage = totalPages;
         startPage = Math.max(1, endPage - maxVisiblePages + 1);
      }

      for (let i = startPage; i <= endPage; i++) {
         pages.push(i);
      }
      return pages;
   };

   const pages = getPageNumbers();

   return (
      <div className="pagination">
         <ul>
            {currentPage > 1 && (
               <li className="btn_prev">
                  <a href="#none" title="이전" onClick={() => onPageChange(currentPage - 1)}>
                     <i><em>이전 아이콘</em></i>
                  </a>
               </li>
            )}
            <></>
            {pages.map((page) => (
               <li key={page} className={page === currentPage ? 'selected' : ''}>
                  <a href="#none" title={page} onClick={() => onPageChange(page)}>
                     {page}
                  </a>
               </li>
            ))}

            {currentPage < totalPages && (
               <li className="btn_next">
                  <a href="#none" title="다음" onClick={() => onPageChange(currentPage + 1)}>
                     <i><em>다음 아이콘</em></i>
                  </a>
               </li>
            )}
         </ul>
      </div>
   );
}

async function setWord(md, idx) {
   const publicUrl = process.env.REACT_APP_POCKET_WWW;
   setCookie('JUMP_URI', publicUrl);
   try {
      const response = await axios.get(publicUrl + '/api/setWord.php?md=' + md + '&idx=' + idx);
      if (response.data == 'NO') {
         window.location.href = loginUrl;
      }
      return response.data;
   } catch (error) {
      console.log(error.message);
      return false;
   };
}
export default withRouter(MyZzim);